import {
    BASE_URL_INVENTORY
  } from "../../CONSTANTS";
  import { SYSTEM_ERROR } from "../../config/CONSTANTS";
  import axios from "axios";
  import Cookies from "universal-cookie";
  
  const cook = new Cookies().get("loginData1");
  
  const headersdata = {
    "content-type": "application/json",
    Accept: "application/json",
    Authorization: cook != undefined ? cook.accessToken : "",
  };
  
  export const addEWay = (data) => {
    return new Promise((resolve, reject) => {
      try {
        axios
          .get(BASE_URL_INVENTORY() + "settings/",data, { headers: headersdata })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject("Error in addEWay axios!");
          });
      } catch (error) {
        reject(SYSTEM_ERROR);
      }
    });
  };